// Central, typed query-key factory. Avoids stringly-typed keys scattered across
// hooks and makes cache invalidation consistent. Each leaf returns a readonly
// tuple used directly as a TanStack Query key.
export const queryKeys = {
  user: {
    all: ['user'] as const,
    details: () => ['user', 'details'] as const,
  },
  playlists: {
    all: ['playlists'] as const,
    curated: () => ['playlists', 'curated'] as const,
  },
  songs: {
    all: ['songs'] as const,
    metadata: (id: string) => ['songs', 'metadata', id] as const,
    youtubeSuggestions: (searchStr: string) => ['songs', 'youtube-suggestions', searchStr] as const,
    search: (searchStr: string) => ['songs', 'search', searchStr] as const,
  },
  filters: {
    all: ['filters'] as const,
    list: () => ['filters', 'list'] as const,
  },
  projects: {
    all: ['projects'] as const,
    ids: () => ['projects', 'ids'] as const,
  },
} as const;
